import { output, input } from '@b2b/types/core';
import angular from 'angular';

class CheckLimitsController {
  static $inject = ['$element'];

  disabled = input(false);
  submitting = input(false);
  label = input<string>();

  onCheckLimits = output<void>();

  private readonly defaultLabel = 'Check limits';

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-check-limits');
  }

  getLabel(): string {
    return this.label ?? this.defaultLabel;
  }

  handleClick() {
    if (!this.disabled && !this.submitting) {
      this.onCheckLimits();
    }
  }
}

export const CheckLimitsComponentModule = angular
  .module('acme.common.component.check-limits', [])
  .component('acmeCheckLimits', {
    templateUrl: 'common/components/check-limits/check-limits.component.tpl.html',
    controller: CheckLimitsController,
    controllerAs: '$ctrl',
    bindings: {
      disabled: '<',
      submitting: '<',
      label: '<',
      onCheckLimits: '&',
    },
  }).name;

